import { Component, ViewChild } from '@angular/core';
import { Platform, MenuController,AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Nav } from 'ionic-angular';

import { PaisesPage } from '../pages/paises/paises'
import { CompaniasPage } from '../pages/companias/companias'
import { UsuariosPage } from '../pages/usuarios/usuarios'
import { CargosPage } from '../pages/cargos/cargos'
import { MesasPage } from '../pages/mesas/mesas';
import { TurnosPage } from '../pages/turnos/turnos'
import { ProductosPage } from '../pages/productos/productos'
import { CajaPage } from '../pages/caja/caja'
import { GruposProductosPage } from '../pages/gruposProductos/gruposProductos'
import { ProductosPorGruposPage } from '../pages/productos-por-grupos/productos-por-grupos'
import { ClientesPage } from '../pages/clientes/clientes'
import { DepartamentosPage } from '../pages/departamentos/departamentos'
import { ProductosElaboradosPage } from '../pages/productos-elaborados/productos-elaborados'
import { ProductosElaboradosContenidoPage } from '../pages/productos-elaborados-contenido/productos-elaborados-contenido'
import { ProveedoresCargarStockPage } from '../pages/proveedores-cargar-stock/proveedores-cargar-stock'
import { DenominacionesPage } from '../pages/denominaciones/denominaciones'
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../pages/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion'
import { ProveedoresPage } from '../pages/proveedores/proveedores'
import { ImpresoraPage } from '../pages/impresora/impresora'
import { Storage } from '@ionic/storage'
import { PermisosPage } from '../pages/permisos/permisos'
import { ChatPage } from '../pages/chat/chat'
import { ComandasPage } from '../pages/comandas/comandas'
import { DesperdiciosPage } from '../pages/desperdicios/desperdicios'
import { ImagenesPage } from '../pages/imagenes/imagenes'
import { CompaniasUsuariosPage } from '../pages/companias-usuarios/companias-usuarios'
import { MODO_DESCONECTADO, NUBE_AWS } from "../config/url.servicio"
import { DomiciliosPage } from '../pages/domicilios/domicilios'
import { MeseromeseroPage } from '../pages/meseromesero/meseromesero'
import { CuentasPorCobrarPage } from '../pages/cuentas-por-cobrar/cuentas-por-cobrar'
import { ContenedorPage } from '../pages/contenedor/contenedor'
import { UbicacionPage } from '../pages/ubicacion/ubicacion'
import {ProductosContenedorPage} from '../pages/productos-contenedor/productos-contenedor'
import { ImprimirPage } from '../pages/imprimir/imprimir'
import { VersionamientoPage } from '../pages/versionamiento/versionamiento'
import { ProductosPorGruposDragPage } from '../pages/productos-por-grupos-drag/productos-por-grupos-drag'
import { DomiciliosappPage } from '../pages/domiciliosapp/domiciliosapp';
import { ParametrosCajaPage } from '../pages/parametros-caja/parametros-caja'
import { PermisosOpcionesUsuariosPage } from '../pages/permisos-opciones-usuarios/permisos-opciones-usuarios'
import { ConceptosEgresosPage } from '../pages/conceptos-egresos/conceptos-egresos'
import { UtilsProvider } from '../providers/utils/utils'
import { DianFacturaElectronicaPage } from '../pages/dian-factura-electronica/dian-factura-electronica'
import { EntidadesGeneralesPage } from '../pages/entidades-generales/entidades-generales';
import { SubirRegistrosPage } from '../pages/subir-registros/subir-registros';
import { DevolverVentasPage } from '../pages/devolver-ventas/devolver-ventas';
import { DevolverAbonosPage } from '../pages/devolver-abonos/devolver-abonos';
import { ReeemprimircomandaspedidossalonPage } from '../pages/reeemprimircomandaspedidossalon/reeemprimircomandaspedidossalon';
import { GestionporproductoPage } from '../pages/gestionporproducto/gestionporproducto';
import { GestionCambioPrecioPorProductoPage } from '../pages/gestion-cambio-precio-por-producto/gestion-cambio-precio-por-producto';
import { SimuladorCuentasPorCobrarPage } from '../pages/simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar';
import { CarruselImagePage } from '../pages/carrusel-image/carrusel-image';
import { CrearCarruselImagePage } from '../pages/crear-carrusel-image/crear-carrusel-image';
import { SalonPage } from '../pages/salon/salon';
import { EgresosIngresosDiariosPage } from '../pages/egresos-ingresos-diarios/egresos-ingresos-diarios';
import { InformeGestionesPage } from '../pages/informe-gestiones/informe-gestiones';
import { ReservasPage } from '../pages/reservas/reservas';
import { PoselectronicoPage } from '../pages/poselectronico/poselectronico';
import { MenuPage } from '../pages/menu/menu';
import { GruposReservasPage } from '../pages/grupos-reservas/grupos-reservas';
import { TiposReservasPage } from '../pages/tipos-reservas/tipos-reservas';
import { GruposReservasPorProductoPage } from '../pages/grupos-reservas-por-producto/grupos-reservas-por-producto';
import { TenderoComponent } from '../components/tendero/tendero';
import { ProductosRapidosPage } from '../pages/productos-rapidos/productos-rapidos';
import { ClientesVentasComponent } from '../components/clientes-ventas/clientes-ventas';
import { ReservasValorLiquidarComponent } from '../components/reservas-valor-liquidar/reservas-valor-liquidar';
import { ReservasTiposPorValorPage } from '../pages/reservas-tipos-por-valor/reservas-tipos-por-valor';
import { ReservasSinAsignarPage } from '../pages/reservas-sin-asignar/reservas-sin-asignar';
import { InformeCambiosMaestroComponent } from '../components/informe-cambios-maestro/informe-cambios-maestro';
import { PosElectronicoComponent } from '../components/pos-electronico/pos-electronico';
import { ProveedoraPorProductoComponent } from '../components/proveedora-por-producto/proveedora-por-producto';
import { ProveedoraPorProductoEquivalenciaComponent } from '../components/proveedora-por-producto-equivalencia/proveedora-por-producto-equivalencia';
import { ProveedoraActualizarProductoComponent } from '../components/proveedora-actualizar-producto/proveedora-actualizar-producto';
import { FacturaSelectComponent } from '../components/factura-select/factura-select';
import { EstadosParqueaderoComponent } from '../components/estados-parqueadero/estados-parqueadero';
import { EstadosParqueaderosPorValorComponent } from '../components/estados-parqueaderos-por-valor/estados-parqueaderos-por-valor';
import { ParqueaderosComponent } from '../components/parqueaderos/parqueaderos';
import { ReservasGrupalesComponent } from '../components/reservas-grupales/reservas-grupales';
import { ProductosRapidosComponent } from '../components/productos-rapidos/productos-rapidos';
import { MovimientosElectronicosComponent } from '../components/movimientos-electronicos/movimientos-electronicos';
import { InformesMovimientosElectronicosComponent } from '../components/informes-movimientos-electronicos/informes-movimientos-electronicos';
import { FormaPagoPopoverComponent } from '../pages/forma-pago-popover/forma-pago-popover';
import { ImprimirGlobalComponent } from '../pages/imprimir-global/imprimir-global';
import { InteresesCreditosComponent } from '../pages/intereses-creditos/intereses-creditos';
import { CreditosComponent } from '../components/creditos/creditos';
import { CostosadicionalesPage } from '../pages/costosadicionales/costosadicionales';
import { InteresesCreditosPorCostosAdicionalesComponent } from '../pages/intereses-creditos-por-costos-adicionales/intereses-creditosporcostosadicionales';
import { GestionarInteresesCreditosPorCostosAdicionalesComponent } from '../pages/gestionar-interes-creditos-por-costos-adicionales/gestionar-interes-creditos-por-costos-adicionales';
import { CuentasPorCobrarCreditosPage } from '../pages/cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos';
import { CuentasPorCobrarCreditosVisualizarPage } from '../pages/cuentas-por-cobrar-creditos-visualizar/cuentas-por-cobrar-creditos-visualizar';
import { ProductosCamposAdicionalesComponent } from '../components/productos-campos-adicionales/productos-campos-adicionales';
import { ProductosCamposAdicionalesCambiarValorComponent } from '../components/productos-campos-adicionales-cambiar-valor/productos-campos-adicionales-cambiar-valor';
import { CuadreCajaDiarioDomiciliosPage } from '../pages/cuadre-caja-diario-domicilios/cuadre-caja-diario-domicilios';
import { CuentasPorCobrarCreditosVisualizarPlanDePagosPage } from '../pages/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos';
import { ProductosTransladosComponent } from '../components/productos-translados/productos-translados';
import { ParametrosCreditosPage } from '../pages/parametros-creditos/parametros-creditos';
import { ConfiguracioncoloresPage } from '../pages/configuracioncolores/configuracioncolores';
import { CallcenterPage } from '../pages/callcenter/callcenter';
import { CajaverticalPage } from '../pages/cajavertical/cajavertical';
import { PersonalizarPage } from '../pages/personalizar/personalizar';
import { FormasDePagoPage } from '../pages/formasdepago/formasdepago';
import { ProductosCamposAdicionalesCambiarValorImpuestosComponent } from '../components/productos-campos-adicionales-cambiar-valor-impuestos/productos-campos-adicionales-cambiar-valor-impuestos';
import { ShortcutConfiguratorComponent } from '../components/shortcutconfigurator/shortcut-configurator';
import { UsuarioPedidoSalonComponent } from '../components/usuariopedidosalon/usuariopedidosalon';
import { TecladoComponent } from '../components/teclado/teclado';
import { ProductorapidocajaverticalComponent } from '../components/productorapidocajavertical/productorapidocajavertical';
import { ModalSeleccionComponent } from '../components/modalseleccion/modalseleccion';
import { inventarioPage } from '../pages/inventario/inventario';
import { IaComponent } from '../components/ia/ia';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = 'LoginPage';

  // rootPage: any = 'PrincipalwebPage';
  PaisesPage = PaisesPage
  CompaniasPage = CompaniasPage
  UsuariosPage = UsuariosPage
  CargosPage = CargosPage
  MesasPage = MesasPage
  TurnosPage = TurnosPage
  ProductosPage = ProductosPage
  CajaPage = CajaPage
  GruposProductosPage = GruposProductosPage
  ProductosPorGruposPage = ProductosPorGruposPage
  ClientesPage = ClientesPage
  DepartamentosPage = DepartamentosPage
  ProductosElaboradosPage = ProductosElaboradosPage
  ProductosElaboradosContenidoPage = ProductosElaboradosContenidoPage
  ProveedoresCargarStockPage = ProveedoresCargarStockPage
  DenominacionesPage = DenominacionesPage
  CuadreCajaDiarioValoresPorDenominacionPage = CuadreCajaDiarioValoresPorDenominacionPage
  ProveedoresPage = ProveedoresPage
  ImpresoraPage = ImpresoraPage
  recorrerVal = []
  PermisosPage = PermisosPage
  ChatPage = ChatPage
  ComandasPage = ComandasPage
  imageUrl:string= MODO_DESCONECTADO ? './../assets/logo_desconectado.png' : './../assets/logo.png'
  DesperdiciosPage = DesperdiciosPage
  ImagenesPage = ImagenesPage
  CompaniasUsuariosPage = CompaniasUsuariosPage
  DomiciliosPage = DomiciliosPage
  MeseromeseroPage = MeseromeseroPage
  CuentasPorCobrarPage = CuentasPorCobrarPage
  ContenedorPage = ContenedorPage
  UbicacionPage = UbicacionPage
  ProductosContenedorPage = ProductosContenedorPage
  ImprimirPage = ImprimirPage
  VersionamientoPage = VersionamientoPage
  ProductosPorGruposDragPage = ProductosPorGruposDragPage
  DomiciliosappPage = DomiciliosappPage
  ParametrosCajaPage = ParametrosCajaPage
  PermisosOpcionesUsuariosPage = PermisosOpcionesUsuariosPage
  ConceptosEgresosPage=ConceptosEgresosPage
  DianFacturaElectronicaPage=DianFacturaElectronicaPage
  EntidadesGeneralesPage = EntidadesGeneralesPage
  SubirRegistrosPage = SubirRegistrosPage
  DevolverVentasPage = DevolverVentasPage
  DevolverAbonosPage = DevolverAbonosPage
  ReeemprimircomandaspedidossalonPage = ReeemprimircomandaspedidossalonPage
  GestionporproductoPage = GestionporproductoPage
  GestionCambioPrecioPorProductoPage = GestionCambioPrecioPorProductoPage
  SimuladorCuentasPorCobrarPage = SimuladorCuentasPorCobrarPage
  CarruselImagePage = CarruselImagePage
  CrearCarruselImagePage= CrearCarruselImagePage
  SalonPage= SalonPage
  EgresosIngresosDiariosPage=EgresosIngresosDiariosPage
  InformeGestionesPage=InformeGestionesPage
  ReservasPage=ReservasPage
  PoselectronicoPage=PoselectronicoPage
  MenuPage = MenuPage
  GruposReservasPage = GruposReservasPage
  TiposReservasPage = TiposReservasPage
  GruposReservasPorProductoPage = GruposReservasPorProductoPage
  TenderoComponent = TenderoComponent
  ClientesVentasComponent = ClientesVentasComponent
  ReservasValorLiquidarComponent = ReservasValorLiquidarComponent
  ReservasTiposPorValorPage = ReservasTiposPorValorPage
  ReservasSinAsignarPage = ReservasSinAsignarPage
  InformeCambiosMaestroComponent= InformeCambiosMaestroComponent
  PosElectronicoComponent = PosElectronicoComponent
  ProveedoraPorProductoComponent = ProveedoraPorProductoComponent
  ProveedoraPorProductoEquivalenciaComponent = ProveedoraPorProductoEquivalenciaComponent
  ProveedoraActualizarProductoComponent = ProveedoraActualizarProductoComponent
  FacturaSelectComponent = FacturaSelectComponent
  EstadosParqueaderoComponent = EstadosParqueaderoComponent
  EstadosParqueaderosPorValorComponent = EstadosParqueaderosPorValorComponent
  ParqueaderosComponent = ParqueaderosComponent
  ReservasGrupalesComponent = ReservasGrupalesComponent
  ProductosRapidosComponent = ProductosRapidosComponent
  MovimientosElectronicosComponent = MovimientosElectronicosComponent
  InformesMovimientosElectronicosComponent = InformesMovimientosElectronicosComponent
  FormaPagoPopoverComponent = FormaPagoPopoverComponent
  ImprimirGlobalComponent = ImprimirGlobalComponent
  InteresesCreditosComponent = InteresesCreditosComponent
  CreditosComponent = CreditosComponent
  CostosadicionalesPage = CostosadicionalesPage
  InteresesCreditosPorCostosAdicionalesComponent = InteresesCreditosPorCostosAdicionalesComponent
  GestionarInteresesCreditosPorCostosAdicionalesComponent = GestionarInteresesCreditosPorCostosAdicionalesComponent
  CuentasPorCobrarCreditosPage = CuentasPorCobrarCreditosPage
  CuentasPorCobrarCreditosVisualizarPage = CuentasPorCobrarCreditosVisualizarPage
  ProductosCamposAdicionalesComponent = ProductosCamposAdicionalesComponent
  ProductosCamposAdicionalesCambiarValorComponent = ProductosCamposAdicionalesCambiarValorComponent
  CuadreCajaDiarioDomiciliosPage = CuadreCajaDiarioDomiciliosPage
  CuentasPorCobrarCreditosVisualizarPlanDePagosPage = CuentasPorCobrarCreditosVisualizarPlanDePagosPage
  ProductosTransladosComponent = ProductosTransladosComponent
  ParametrosCreditosPage = ParametrosCreditosPage
  ConfiguracioncoloresPage = ConfiguracioncoloresPage
  CallcenterPage = CallcenterPage
  CajaverticalPage = CajaverticalPage
  PersonalizarPage = PersonalizarPage
  FormasDePagoPage = FormasDePagoPage
  ProductosCamposAdicionalesCambiarValorImpuestosComponent = ProductosCamposAdicionalesCambiarValorImpuestosComponent
  ShortcutConfiguratorComponent = ShortcutConfiguratorComponent
  UsuarioPedidoSalonComponent = UsuarioPedidoSalonComponent
  TecladoComponent = TecladoComponent
  ProductorapidocajaverticalComponent = ProductorapidocajaverticalComponent
  ModalSeleccionComponent = ModalSeleccionComponent
  inventarioPage = inventarioPage
  IaComponent = IaComponent
  @ViewChild(Nav) nav: Nav;
  fabVisible:boolean = false
  versionAWS: Boolean = NUBE_AWS

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
              public menuControllers:MenuController,
              public storages:Storage,
              public alertControllers:AlertController,
              public mensajes:UtilsProvider,private storage: Storage
              ) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }



  ionViewDidLoad() {
  }

  abrirPagina(pagina:any,nombre:string){
    // this.rootPage = pagina

    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        // this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
        this.mensajes.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique.', 'warning')
      }else{
        this.fabVisible = true
        this.nav.push(pagina,{data:data});
        this.menuControllers.close()
      }

    })

  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }
  isActive(page: string) {
    const pageActive = this.nav.getActive();
    if (pageActive) {
      return page === pageActive.name;
    }
    return false;
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts